import { WelcomeMessage } from '@/models'
import { WelcomeMessageCard } from './WelcomeMessageCard'

type WelcomeMessagesListProps = {
    welcomeMessages: WelcomeMessage[]
}

export function WelcomeMessagesList({ welcomeMessages }: WelcomeMessagesListProps) {
    return (
        <>
            {welcomeMessages?.map((message, index) => (
                <WelcomeMessageCard key={index} {...message} />
            ))}
        </>
    )
}
